import { ReactNode } from "react";
import { Paper, useMediaQuery } from "@mui/material";

import { useTypedTheme } from "hooks";

type Props = {
  children: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refSectionBox: any;
  step: "step-1" | "step-2" | "step-3" | "step-4" | "step-5" | "step-6";
};

export const SectionBox = ({ children, refSectionBox, step }: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const isMobile = useMediaQuery(down("md"));

  return (
    <Paper
      ref={refSectionBox}
      elevation={10}
      sx={{
        padding: [2, 4, 6, 8],
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? 1.6 : 4,
        borderRadius: 4,
      }}
      style={{
        paddingTop: isMobile ? "30px" : step === "step-2" ? "35px" : "50px",
      }}
    >
      {children}
    </Paper>
  );
};
